import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import RegionSwitcher from '../RegionSwitcher';
import {
  REGION_CHANGE_EVENT,
  REGIONS,
  getRegion,
  isIndiaPath,
} from '../../utils/region';

export default function Header() {
  const { pathname } = useLocation();
  const [region, setRegionState] = useState(() => getRegion());
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const sync = (event) => setRegionState(event.detail || getRegion());
    window.addEventListener(REGION_CHANGE_EVENT, sync);
    return () => window.removeEventListener(REGION_CHANGE_EVENT, sync);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const india = region === REGIONS.IN || isIndiaPath(pathname);
  const homeHref = india ? '/in' : '/';

  const isActive = (path) =>
    pathname === path || pathname.startsWith(path + '/') ? 'active' : '';
  const homeActive = india
    ? isIndiaPath(pathname)
    : pathname === '/' || pathname === '/homepage';

  const HomeTag = india ? 'a' : Link;
  const homeProps = india ? { href: homeHref } : { to: homeHref };

  return (
    <nav id="nav" className={menuOpen ? 'is-open' : undefined}>
      <HomeTag {...homeProps} className="n-logo">
        <img className="n-mark" src="/favicon.ico" alt="" width="32" height="32" />
        {india ? 'Praesidio Studio' : 'Praesidio Care'}
      </HomeTag>

      <ul className="n-links" id="nav-links">
        <li>
          <HomeTag
            {...homeProps}
            id="nav-home"
            className={homeActive ? 'active' : ''}
          >
            Home
          </HomeTag>
        </li>
        <li>
          <Link
            to="/about-us"
            id="nav-about"
            className={isActive('/about-us')}
          >
            About
          </Link>
        </li>
        <li>
          <Link
            to="/contact"
            id="nav-contact"
            className={isActive('/contact')}
          >
            Contact
          </Link>
        </li>
      </ul>

      <div className="n-right">
        <button
          type="button"
          className="n-menu"
          aria-expanded={menuOpen}
          aria-controls="nav-links"
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? 'Close' : 'Menu'}
        </button>
        <RegionSwitcher />
        <Link to="/contact" className="n-cta">
          BOOK A CALL →
        </Link>
      </div>
    </nav>
  );
}

